import { useEffect, useRef } from 'react';

import { useHeaderContext } from '@udacity/udacity-header-v2';

import { HEADER_SEARCH_ORIGIN } from '../constants';
import { setCatalogSearchDraft, useCatalogSearchDraft } from '../utils/catalog-search-draft';

export function CatalogSearchHeaderBridge() {
  const headerSearchValue = useHeaderContext((state) => state.searchValue);
  const updateSearch = useHeaderContext((state) => state.updateSearch);
  const draft = useCatalogSearchDraft();
  const previousDraft = useRef(draft);
  const previousHeaderSearchValue = useRef(headerSearchValue);
  const previousUpdateSearch = useRef(updateSearch);

  useEffect(() => {
    // UdacityHeader recreates its store (with an empty searchValue) whenever its props change,
    // so a new store is seeded from the inline draft instead of clearing it.
    if (updateSearch !== previousUpdateSearch.current) {
      previousUpdateSearch.current = updateSearch;
      previousDraft.current = draft;
      previousHeaderSearchValue.current = draft;
      if (draft !== headerSearchValue) {
        updateSearch(draft);
      }
      return;
    }

    // Only the side that changed since the last sync is copied, otherwise both sides
    // would overwrite each other with stale values on every render.
    if (draft !== previousDraft.current) {
      previousDraft.current = draft;
      if (draft !== headerSearchValue) {
        previousHeaderSearchValue.current = draft;
        updateSearch(draft);
      }
      return;
    }

    if (headerSearchValue !== previousHeaderSearchValue.current) {
      previousHeaderSearchValue.current = headerSearchValue;
      if (headerSearchValue !== draft) {
        previousDraft.current = headerSearchValue;
        setCatalogSearchDraft(headerSearchValue, HEADER_SEARCH_ORIGIN);
      }
    }
  }, [draft, headerSearchValue, updateSearch]);

  return null;
}
